import { render, staticRenderFns } from "./BaseUpIcon.vue?vue&type=template&id=ef9797ea"
import script from "./BaseUpIcon.vue?vue&type=script&lang=js"
export * from "./BaseUpIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports